var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "545 4470 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a8a8a8;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(414 2325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(1 2.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-1",
    d: "M374.795,385.9H318.805c-2.493,0-3.352,1.395-3.352,3.122s.858,3.122,3.352,3.122h55.989c2.493,0,3.505-1.395,3.505-3.122S377.288,385.9,374.795,385.9Z",
    transform: "translate(-176.454 1794.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-1",
    d: "M374.795,385.9H318.805c-2.493,0-3.352,1.395-3.352,3.122s.858,3.122,3.352,3.122h55.989c2.493,0,3.505-1.395,3.505-3.122S377.288,385.9,374.795,385.9Z",
    transform: "translate(559.143 1835.873) rotate(90)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    className: "cls-2",
    width: 80,
    height: 80,
    transform: "translate(131 2145)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.67f70e63fd01c3fc953fe8ca8d63ff7b.svg";
export { ForwardRef as ReactComponent };